module.exports = __webpack_public_path__ + "img/online-process.912fd23b.svg";